module.exports = __webpack_public_path__ + "static/media/loading.e4b6323e.gif";